import React from 'react';
import { Subject, Topic } from '../types';

interface TopicsListProps {
  selectedSubject: Subject | null;
  topics: Topic[];
  loading: boolean;
  loadLesson: (topic: Topic) => void;
}

export const TopicsList: React.FC<TopicsListProps> = ({
  selectedSubject,
  topics,
  loading,
  loadLesson
}) => {
  if (!selectedSubject) return null;

  return (
    <div>
      <div style={{ marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '12px' }}>
        <span style={{ fontSize: '32px' }}>{selectedSubject.icon}</span>
        <div>
          <h2 style={{ margin: '0 0 4px 0' }}>{selectedSubject.name} Topics</h2>
          <p style={{ margin: 0, color: '#6b7280', fontSize: '14px' }}>Select a topic to start learning</p>
        </div>
      </div>
      
      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <div style={{ width: '40px', height: '40px', border: '3px solid #e5e7eb', borderTopColor: '#22c55e', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }}></div>
        </div>
      ) : topics.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px', background: 'white', borderRadius: '16px' }}>
          <p style={{ color: '#6b7280' }}>No topics available for this subject yet.</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: '16px' }}>
          {topics.map(topic => (
            <div 
              key={topic.id}
              onClick={() => loadLesson(topic)}
              style={{
                background: 'white',
                borderRadius: '16px',
                padding: '24px',
                border: '1px solid #e5e7eb',
                cursor: 'pointer',
                transition: 'all 0.2s',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#22c55e';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.05)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#e5e7eb';
                e.currentTarget.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
              }}
            >
              <div style={{ flex: 1 }}>
                <h3 style={{ margin: '0 0 8px 0', fontSize: '18px', color: '#1f2937' }}>{topic.title}</h3>
                <p style={{ margin: 0, color: '#6b7280', fontSize: '14px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                  {topic.content_preview}
                </p>
              </div>
              <div style={{ 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%', 
                background: '#f0fdf4', 
                color: '#22c55e',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px',
                marginLeft: '16px',
                flexShrink: 0
              }}>
                →
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
